import $ from 'jquery';

import Modal from './Modal';
import ProductDetails from './ProductDetails';
import RichText from '../components/RichText';
import {removeTrapFocus} from '../helpers/a11y';

export default class ProductQuickshop {
  constructor(options) {
    this.$el = options.$el;
    this.modalClass = options.modalClass;
    this.loaded = false;
    this.richText = null;
    this.productDetails = null;

    try {
      this.data = JSON.parse(this.$el.find('[data-product-quickshop-data]').text());
    } catch (error) {
      console.warn(`Quickshop: invalid quickshop data found. ${error.message}`);
      return;
    }

    this.$message = this.$el.find('[data-product-quickshop-message]');
    this.$formArea = this.$el.find('[data-product-form-area]');
    this.$gallery = this.$el.find('[data-product-gallery]');
    this.$details = this.$el.find('[data-product-details]');
    this.$description = this.$el.find('[data-product-description]');
    this.context = this.data.context;
    this.settings = this.data.settings;
    this.product = this.data.product;

    this._open = this._open.bind(this);
    this._close = this._close.bind(this);

    this._onATCClose = this._onATCClose.bind(this);
    this._onATCInit = this._onATCInit.bind(this);
    this._onATCError = this._onATCError.bind(this);
    this._onATCSuccess = this._onATCSuccess.bind(this);

    const modalCallbacks = {
      onOpen: this._open,
      onClose: this._close,
    };

    this.atcCallbacks = {
      onClose: this._onATCClose,
      onInit: this._onATCInit,
      onError: this._onATCError,
      onSuccess: this._onATCSuccess,
    };

    this.modal = new Modal(modalCallbacks);
    this.modal.open(`[data-product-quickshop="${this.product.id}"]`, this.modalClass);
  }

  _open() {
    if (this.loaded) {
      return;
    }

    this.richText = new RichText(this.$description);

    const options = {
      $formArea: this.$formArea,
      $gallery: this.$gallery,
      $details: this.$details,
      atcCallbacks: this.atcCallbacks,
      context: this.context,
      settings: this.settings,
      product: this.product,
      useHistory: false,
    };

    this.productDetails = new ProductDetails(options);
  }

  _close() {
    if (this.productDetails) {
      this.productDetails.unload();
    }

    if (this.richText) {
      this.richText.unload();
    }

    this._toggleMessage('', false);
    this.modal.unload();
  }

  _toggleMessage(message, isVisible) {
    this.$message
      .html(message)
      .toggleClass('visible', isVisible);
  }

  _onATCClose() {
    removeTrapFocus({
      namespace: 'product-details-flyout',
    });

    this.$el.focus();
  }

  _onATCInit() {
    this.$message.removeClass('visible');
  }

  _onATCError(error) {
    const $content = $(`<div class="product-message--error">${error}</div>`);
    this._toggleMessage($content, true);
  }

  _onATCSuccess() {
    this._close();
  }

  unload() {
    this._close();
  }
}
